export { default as AdSummaryBottom } from './AdSummaryBottom';



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdSummaryBottom/index.ts